import { type OptionType } from '@hivebrite/design-system/Inputs';

/**
 * Converts TData values to OptionType format
 */
export const convertToOptions = <
  TData extends object,
  TOptionType extends OptionType,
>(
  value: Array<TData> | TData,
  toOptionsFn: (data: Array<TData>) => Array<TOptionType>,
): Array<TOptionType> | TOptionType => {
  if (Array.isArray(value)) {
    return toOptionsFn(value);
  }

  return toOptionsFn([value])[0];
};
